<template>
	<div class="u" v-if="$store.state.userInfo">
		<div class="ucenter-panel">
			<div class="ucenter-panel-avatar">
				<img :src="$store.state.userInfo.avatar && $store.state.userInfo.avatar != '' ? $store.state.userInfo.avatar : require('@/assets/images/head.png')" alt="" />
			</div>
			<div class="ucenter-panel-main">
				<div class="u-head-title">{{$t('嗨')}} {{$store.state.userInfo.level_name}} {{$store.state.userInfo.user_name}}</div>
				<div class="slider-main">
					<div class="slider-attr">
						<span>{{formatNumber($store.state.userInfo.total_price)}} / {{formatNumber($store.state.userInfo.next_level.fee)}}</span>
						<a href="javascript:;" @click="showVip" class="text-primary">
							{{$t('会员等级说明')}}
						</a>
					</div>
					<div class="slider-progress">
						<div class="slider-progress-bar" :style="{ width: progressPercentage + '%' }"></div>
					</div>
					<div class="slider-attr">
						<span>{{$store.state.userInfo.level_name}}</span><span>{{$store.state.userInfo.next_level.level_name}}</span>
					</div>
				</div>
			</div>
			<div class="ucenter-panel-info">
				<div class="flex-col">
					<div class="u-panel-item">
						{{$t('积分')}}：<span class="text-primary">{{formatNumber($store.state.userInfo.user_money)}} </span>
						
					</div>
				</div>
			</div>
		</div>
		<vipDialog ref="vipMok"></vipDialog>
	</div>
</template>
<script>
	import vipDialog from './vipDialog'
	export default {
		components: {
			vipDialog,
		},
		computed: {
			progressPercentage() {
			  const totalPrice = this.$store.state.userInfo.total_price;
			  const nextLevelFee = this.$store.state.userInfo.next_level.fee;
			  if (nextLevelFee <= 0) return 0; // 防止除以零
			  let percentage = (totalPrice / nextLevelFee) * 100;
			  percentage = Math.min(percentage, 100); // 确保不超过 100%
			  return Math.round(percentage); // 四舍五入到整数
			}
		},
		data() {
			return {
				show: false
			};
		},
		methods:{
			showVip(){
				this.$refs.vipMok.show = true
			},
			showRecharge(){
				this.$refs.Recharge.show = true
			},
			showWithdrawal(){
				this.$refs.Withdrawal.show = true
			},
		},
		mounted() {}
	}
</script>
<style >
	.ucenter-panel {
		overflow: hidden;
		position: relative;
	}
	
	.ucenter-panel::before {
	  content: '';
	  position: absolute;
	  left: 120px;
	  top: -50px;
	  width: 60px;
	  height: 200%;
	  z-index: 0;
	  background: linear-gradient(
	    to bottom right,
	    rgba(255, 255, 255, 0) 0%,
	    rgba(255, 255, 255, 0.4) 50%,
	    rgba(255, 255, 255, 0) 100%
	  );
	  box-shadow: 0 0 20px rgba(255, 255, 255, 0.2);
	  transform: rotate(35deg);
	}
	
	@keyframes glowingEffect {
	  0% {
	    transform: rotate(45deg) translateY(-100%);
	  }
	  100% {
	    transform: rotate(45deg) translateY(100%);
	  }
	}
</style>